(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("DailyTotalReportViewModel", dailyTotalReportViewModelFactory);

  /** @ngInject */
  function dailyTotalReportViewModelFactory(
    reportActions,
    localeFilters,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum
  ) {
    function DailyTotalReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          type: "timeseries",
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        },
        y: {
          tick: {
            rotate: 60
          }
        }
      };

      init.call(this);
    }

    DailyTotalReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return DailyTotalReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      reportActions
        .getFinancesByDate(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          that.isChartVisible = successData.total !== 0;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();
